import {
  Button,
  Layout,
  notification,
  Skeleton,
  theme,
  Typography,
} from "antd";
import React, { useRef } from "react";
import {
  initInstitutionSlice,
  setPropertiesInstitution,
  updateInstitution,
} from "../Slices/Institution.slice";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import routes from "../../../engine/routes";
import { institutionsDetailinputs } from "./InstitutionDetailForm";
import { InstitutionHeader } from "../../../shared/components/InstitutionHeader/InstitutionHeader";
import { http } from "../../../engine/api/http";
import { userHasLevel } from "../../../engine/AuthRoute";
import { roles } from "../../../utils/constants";
import { useTranslation } from 'react-i18next';

const { Content, Sider, Header, Footer } = Layout;

export function InstitutionDetail({ unitId, expanded, onClose }) {
  const { t } = useTranslation();
  const { id } = useParams();

  const { institution, loading } = useSelector(state => state.institution);

  const { init, clear } = initInstitutionSlice({ id });

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const m2Exposant = (
    <span>
      m<sup>2</sup>
    </span>
  );

  const inputs = institutionsDetailinputs({ institution, formRef });

  const onSubmitForm = async data => {
    if (formRef.current._billings !== undefined) {
      data.billings = formRef.current._billings;
    }

    await dispatch(setPropertiesInstitution(data));
    dispatch(updateInstitution());
  };

  return (
    <>
      <InstitutionHeader title={t('InstitutionDetail.title')} />
      {loading ? (
        <Skeleton active />
      ) : (
        <CustomForm
          rule={routes.institutions(id).detail}
          dataSource={inputs}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          onValuesChange={undefined}
        />
      )}
    </>
  );
}
